/**
 * Load color themes again, to set them for elements in the DOM that follow the page color theme.
 */
H_Color_Theme.load();
